import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { IStaticMethods } from 'preline/preline';

declare global {
  interface Window {
    HSStaticMethods: IStaticMethods;
  }
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`
})
export class AppComponent implements OnInit {
  title = 'RM Farma - formulários dinâmicos';

  allowedOrigins = ['https://grupo-hiper-saude.webflow.io', 'https://www.grupohipersaude.com.br', 'https://otimiza.grupohipersaude.com.br/', 'https://ser-associado.rmfarma.com.br/', 'https://rmfarma.com.br/', 'https://hipersaude.com.br/', 'http://localhost:4200/', 'https://dev.rmfarma.io/', 'https://app.rmfarma.io/', 'http://localhost:3000/', 'https://site-rmfarma.pages.dev/', 'https://www.rmfarma.com.br/', 'https://novosite.rmfarma.com.br/', 'https://saas.rmfarma.com.br/', 'https://grupohipersaude.com.br/','https://www.otimiza.grupohipersaude.com.br/', 'https://seja-um-associado-rmfarma.webflow.io/', 'https://somos.grupohipersaude.com.br/', 'https://otimizafarma.com.br/', 'https://www.otimizafarma.com.br/'];

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      import('flowbite').then(module => {
        module.initFlowbite();
      });
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.checkIframeEmbedding();
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            window.HSStaticMethods.autoInit();
          }, 100);
        }
      });
    }
  }

  private checkIframeEmbedding(): void {
    if (window.top !== window.self) {
      // Está em um iframe
      const origin = document.referrer;
      const isAllowed = this.allowedOrigins.some(allowedOrigin => origin.startsWith(allowedOrigin));
      if (!isAllowed) {
        document.body.innerHTML = `
        <div class="flex items-center justify-center h-screen bg-gray-100">
          <div class="text-center">
            <h1 class="text-2xl font-bold text-red-600">Acesso não permitido</h1>
            <p class="mt-2 text-gray-600">Este conteúdo não pode ser embutido em seu site.</p>
          </div>
        </div>
      `;
        console.warn('Embedding site is not allowed');
      }
    }
  }
}
